import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconNotes(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM3 12a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM4 15a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
